export const leaseTypes = [
  {
    id: 'kontor',
    label: 'Kontor',
  },
  {
    id: 'butik',
    label: 'Butik',
  },
  {
    id: 'kontorfaellesskab',
    label: 'Kontorfællesskab',
  },
  {
    id: 'bolig',
    label: 'Bolig',
  },
  {
    id: 'lager',
    label: 'Lager',
  },
  {
    id: 'showroom',
    label: 'Showroom',
  },
  {
    id: 'klinik',
    label: 'Klinik',
  },
]
